module.exports = __webpack_public_path__ + "img/qihang123.7840acec.png";